import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index' // 确保路径正确

Vue.use(VueRouter)

// 引入组件
import Index from '../views/index'
import Orders from '../views/Orders'
import Download from '../views/Download'
import Success from '../views/Success'
import Login from '../views/login'
import Czpage from '../views/CzPage'
import AddPage from '../views/AddPage'
import ThingPage from '../views/ThingPage'
import XCPage from '../views/XCPage'
import WX from '../views/WX'
import Index1 from '../views1/index'
import Orders1 from '../views1/Orders'
import Download1 from '../views1/Download'
import Success1 from '../views1/Success'
import Czpage1 from '../views1/CzPage'
import AddPage1 from '../views1/AddPage'
import ThingPage1 from '../views1/ThingPage'
import XCPage1 from '../views1/XCPage'
import WX1 from '../views1/WX'

// 创建路由器实例
const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: Index,
      meta: { requiresAuth: false } // 修改为需要认证
    },{
      path: '/orders',
      component: Orders,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/download',
      component: Download,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/success',
      component: Success,
      meta: { requiresAuth: false } // 明确标记不需要认证
    },
    {
      path: '/loginadmin',
      component: Login,
      meta: { requiresAuth: false } // 明确标记不需要认证
    },
    {
      path: '/czpage',
      component: Czpage,
      meta: { requiresAuth: false } // 明确标记不需要认证
    },
    {
      path: '/addPage',
      component: AddPage,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/thinglist',
      component: ThingPage,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/xclist',
      component: XCPage,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/wx',
      component: WX,
      meta: { requiresAuth: false } // 明确标记不需要认证
    },
    {
      path: '/1',
      component: Index1,
      meta: { requiresAuth: false } // 修改为需要认证
    },{
      path: '/orders1',
      component: Orders1,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/download1',
      component: Download1,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/success1',
      component: Success1,
      meta: { requiresAuth: false } // 明确标记不需要认证
    },
    {
      path: '/czpage1',
      component: Czpage1,
      meta: { requiresAuth: false } // 明确标记不需要认证
    },
    {
      path: '/addPage1',
      component: AddPage1,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/thinglist1',
      component: ThingPage1,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/xclist1',
      component: XCPage1,
      meta: { requiresAuth: true } // 修改为需要认证
    },
    {
      path: '/wx1',
      component: WX1,
      meta: { requiresAuth: false } // 明确标记不需要认证
    }
  ]
})

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  
  const isAuthenticated = store.state.isLoggedIn

  // 需要认证的页面
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        path: '/loginadmin',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  }
  // 已登录用户访问登录页
  else if (to.path === '/loginadmin' && isAuthenticated) {
    next('/orders') // 重定向到主页
  }
  // 其他情况
  else {
    next()
  }
})

export default router